module.exports = __webpack_public_path__ + "img/nota-codigo-tomason-industrial.1aaabb2f.png";